/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserNotificationSettingsDto } from '../../models/user-notification-settings-dto';

export interface UserControllerGetNotificationSettings$Params {
}

export function userControllerGetNotificationSettings(http: HttpClient, rootUrl: string, params?: UserControllerGetNotificationSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<UserNotificationSettingsDto>> {
  const rb = new RequestBuilder(rootUrl, userControllerGetNotificationSettings.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserNotificationSettingsDto>;
    })
  );
}

userControllerGetNotificationSettings.PATH = '/api/user/me/notification-settings';
